// extracted by mini-css-extract-plugin
export default {"card":"Rota_card__pucnQ","cardbody":"Rota_cardbody__qK+ic"};